import React from "react";
import { Modal } from "antd";

export default function OneInvoiceModal({ visible, data, onClose }) {
	return (
		<Modal
			visible={visible}
			onRequestClose={onClose}
			onCancel={() => {
				onClose();
			}}
			style={{
				content: {
					top: "50%",
					left: "50%",
					right: "auto",
					bottom: "auto",
					marginRight: "-50%",
					transform: "translate(-50%, -50%)",
					borderRadius: "10px",
					border: "none",
					padding: "20px",
					backgroundColor: "white",
					outline: "none",
				},
				overlay: {
					background: "#0000008D",
				},
			}}
			contentLabel="Example Modal"
			ariaHideApp={false}
			footer={null}
		>
			<div
				className={
					"flex h-[200px]  w-[400px] flex-col gap-4 items-center  rounded-3xl pl-5 bg-white drop-shadow-xl"
				}
			>
				<div className="flex items-center justify-center">
					<div className="">
						<h1 className="font-poppins  mt-10 text-xl font-bold text-[#425166]">
							Do'kon : {data?.whsName}
						</h1>
						<div className="flex flex-col mt-5 gap-2">
							<h1 className="font-poppins  text-xl font-bold text-[#151D48]">
								Sotuv summasi :{" "}
								{new Intl.NumberFormat("fr-FR").format(data?.salesDocTotal).replace(/\s/g, "  ")}{" "}
							</h1>
							<h1 className="font-poppins  text-xl font-bold text-[#151D48]">
								Sotuvlar soni :{" "}
								{new Intl.NumberFormat("fr-FR").format(data?.salesCount).replace(/\s/g, "  ")}{" "}
							</h1>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
}
